export enum SeekingIntentId {
    seekingCommence = 'seeking-commence',
    seekingDataEdit = 'seeking-data-edit',
    seekingCancel = 'seeking-cancel',
    seekingSyncLinkCreate = 'seeking-sync-link-create',
    seekingProvisionCreate = 'seeking-provision-create',
    seekingProvisionsAutoSearch = 'seeking-provisions-auto-search',
    seekingUpcomingProvisionActivate = 'seeking-upcoming-provision-activate',
    seekingSeekedActiveProvisionDataEdit = 'seeking-seeked-active-provision-data-edit',
    seekingProvidedActiveProvisionDataEdit = 'seeking-provided-active-provision-data-edit',
    seekingActiveProvisionMessageSend = 'seeking-active-provision-message-send',
    seekingActiveProvisionAccept = 'seeking-active-provision-accept',
    seekingActiveProvisionConditionallyAccept = 'seeking-active-provision-conditionally-accept',
    seekingActiveProvisionConditionAccept = 'seeking-active-provision-condition-accept',
    seekingActiveProvisionReceive = 'seeking-active-provision-receive',
    seekingActiveProvisionExemplarSend = 'seeking-active-provision-exemplar-send',
    seekingActiveProvisionExemplarSendBack = 'seeking-active-provision-exemplar-send-back',
    seekingActiveProvisionExemplarReceiveBack = 'seeking-active-provision-exemplar-receive-back',
    seekingActiveProvisionSeekerCancel = 'seeking-active-provision-seeker-cancel',
    seekingActiveProvisionProviderCancel = 'seeking-active-provision-provider-cancel',
}

export enum SeekingProvisionIntentId {
    seekingProvisionDataEdit = 'seeking-provision-data-edit',
    seekingProvisionCancel = 'seeking-provision-cancel',
}